// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.daBqZkYeVxIkv5 {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 19px;
}
.P86YjktdDsNM_n select,
.P86YjktdDsNM_n input {
  width: 100%;
}
.R1FmqNQGU60Wlf {
  padding: 10px 18px;
  white-space: nowrap;
}
@media only screen and (min-width: 751px) and (max-width: 900px), only screen and (max-width: 750px) {
  .R1FmqNQGU60Wlf {
    width: 100%;
    text-align: center;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinner": `daBqZkYeVxIkv5`,
	"container": `P86YjktdDsNM_n`,
	"button": `R1FmqNQGU60Wlf`
};
export default ___CSS_LOADER_EXPORT___;
